import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseOutlined from '@mui/icons-material/CloseOutlined';

import { DrawerHeaderButton } from '@/shared/ui';

import { useDrawerSteps } from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { DrawerHeader } from '@/features/dashboard/components/Drawer/DrawerHeader';

import { useSaveApp } from './useSaveApp';

const AddAppHeader = () => {
  const { handleAttemptBack, isEditMode, handleAttemptClose } = useDrawerSteps();
  const { isPending } = useSaveApp();

  return (
    <DrawerHeader
      before={
        <DrawerHeaderButton
          disabled={isPending}
          label='Go back'
          onClick={handleAttemptBack}
        >
          <ArrowBackIcon />
        </DrawerHeaderButton>
      }
      buttons={
        <DrawerHeaderButton
          disabled={isPending}
          label='Discard'
          onClick={() => {
            if (!isPending) {
              handleAttemptClose();
            }
          }}
        >
          <CloseOutlined />
        </DrawerHeaderButton>
      }
      title={isEditMode ? 'Edit app' : 'Add new app'}
    />
  );
};

export default AddAppHeader;
